import { useQueryParamHelper } from '@shared/core/queryString';

export const useRedirectFromCreateBabyRegistry = () => {
  const queryParamHelper = useQueryParamHelper();
  const scenario = queryParamHelper.getValueString('scenario') ?? '';
  return (website: string) =>
    (window.location.href = new URL(
      `/${website}/edit/registry${
        scenario === 'baby-registry' ? '/shop' : scenario === 'add-from-friends-registry' ? '/add-from-friends-registry?feature.enableaddfromfriendsregistry=true' : ''
      }`,
      window.location.origin
    ).href);
};
